import React, { useEffect, useState, useRef } from "react";
import {
  Alert as MuiAlert,
  Box,
  Grid,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { spacing } from "@mui/system";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import ReplayIcon from "@mui/icons-material/Replay";
import { useDispatch } from "react-redux";

import { useDialog } from "../../../../contexts/DialogContext";
import useUser from "../../../../hooks/useUser";
import CustomTextField from "../../../../components/CustomTextField";

import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";

const Alert = styled(MuiAlert)(spacing);

const validationSchema = Yup.object().shape({
  routerPassword: Yup.string().max(255).required("Router password is required"),
  confirmRouterPassword: Yup.string()
    .required("Router password is required")
    .when("routerPassword", {
      is: (val) => (val && val.length > 0 ? true : false),
      then: () =>
        Yup.string().oneOf([Yup.ref("routerPassword")], "Both password need to be the same"),
    }),
});

const ChangeRouterPassword = (props) => {
  const dispatch = useDispatch();
  const { isRenewSubmitting, updateRouterPassword } = useUser();
  const { userName, refreshPage } = props;
  const currentPolicyPayload = {
    filters: [],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [],
  };

  const { t } = useTranslation();

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });
  const {
    reset,
    handleSubmit,
    watch,
    resetField,
    formState: { errors },
    control,
  } = methods;
  const { unSetDialog, openDialog } = useDialog();

  const onSubmit = async (data) => {
    try {
      const payload = {
        userName: userName,
        password: data.routerPassword,
      };
      await updateRouterPassword(payload);
      dispatch(showSuccessSnackbar("Router password changed successfully!"));
      unSetDialog("change_router_password");
      if (typeof refreshPage === "function") {
        refreshPage();
      }
    } catch (ex) {
      dispatch(showErrorSnackbar(ex.message));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <CustomTextField
                label={t("password")}
                name="routerPassword"
                type="password"
                my={2}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item md={6}>
              <CustomTextField
                label={t("confirm_password")}
                name="confirmRouterPassword"
                type="password"
                my={2}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<ReplayIcon />}
              endIcon={isRenewSubmitting ? <CircularProgress size={24} /> : null}
              disabled={false}
            >
              Save
            </Button>

            <Button
              variant="text"
              onClick={() => unSetDialog("change_router_password")}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
};
export default ChangeRouterPassword;
